import { AxiosInstance } from 'axios';
import * as ArrivalReportService from './services';

export type ArrivalReportServiceType = ReturnType<typeof ArrivalReportService.exportPDF>;

export const initArrivalReportService = (axios: AxiosInstance): ArrivalReportServiceType =>
  ArrivalReportService.exportPDF(axios);
